import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Check_Large, Warning_Fill } from '@spaces-ui/meadow/icons/svgs';

import { ToastMessageConfig } from '../toast-message-config';

@Component({
  selector: 'mdw-notifications-message',
  templateUrl: './toast-message.html',
  styleUrls: ['./toast-message.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwIcon],
})
export class MdwToastMessage {
  public data = inject(MAT_SNACK_BAR_DATA) as ToastMessageConfig;

  public icons = {
    Check_Large,
    Warning_Fill,
  };
}
